import { MemoCircleCheck } from '../../../assets/icons/MemoCircleCheck';
import pdfCarePlus from '../../../assets/documents/HIS_USWTCCP_0626_31_100.pdf';
import pdfReplacementCare from '../../../assets/documents/HIS_USWTCRC_0626_03_100.pdf';

export type QuoteTermsAndConditionsPanelProps = {
  brand: string;
  alignIcon?: 'center' | 'start';
  hasReplacementCare?: boolean;
};

export const QuoteTermsAndConditionsPanel = ({
  brand,
  hasReplacementCare = false,
}: QuoteTermsAndConditionsPanelProps) => (
  <div className="flex">
    <div className="shrink-0">
      <MemoCircleCheck />
    </div>
    <div className="flex flex-col items-start gap-space-400 pl-space-400">
      <p>
        *Limitations and exclusions apply. Please see the complete{' '}
        <a
          className="text-body-link-strong"
          href={!hasReplacementCare ? pdfCarePlus : pdfReplacementCare}
          target="_blank"
          rel="noopener noreferrer"
        >
          {brand} terms and conditions
        </a>{' '}
        for details.
      </p>

      {!hasReplacementCare && (
        <p className="text-body-small">
          Manufacturer's warranty terms and conditions may vary depending on the appliance. Please
          check with the retailer you bought your product from for more information.
        </p>
      )}
    </div>
  </div>
);
